/**
 * Get value of parameter in url
 * @param {string} name 
 * @returns value of parameter in url
 */
export const getUrlParameter = (name: string): string | null => {
  if (typeof window !== "undefined") {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
  }
  return null;
};

/**
 * Check if url has a particular parameter
 * @param {string} name 
 * @returns boolean
 */
export const hasUrlParameter = (name: string): boolean => {
  if (typeof window !== "undefined") {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.has(name);
  }
  return false;
};

export function setQueryParam(key: string, value: string | number, pageRefresh = false, preserveBrowserHistory = false) {
  if (typeof window === "undefined") return;
  
  let url = new URL(window.location.href);
  url.searchParams.set(key, String(value));
  let newUrl = url.toString();

  if (pageRefresh) {
    window.location.href = newUrl;
  } else if (preserveBrowserHistory) {
    window.history.pushState({}, '', newUrl);
  } else {
    window.history.replaceState({}, '', newUrl);
  }  
}

export function deleteQueryParam(key: string, pageRefresh = false, preserveBrowserHistory = false) {
  if (typeof window === "undefined") return;
  
  let url = new URL(window.location.href);
  url.searchParams.delete(key);
  let newUrl = url.toString();

  if (pageRefresh) {
    window.location.href = newUrl;
  } else if (preserveBrowserHistory) {
    window.history.pushState({}, '', newUrl);
  } else {
    window.history.replaceState({}, '', newUrl);
  }
}

